(function (Drupal, $, settings) {

  Drupal.behaviors.cart = {
    attach: function attach(context) {
      const data = localStorage.getItem('reduxStore');
      // console.log('data', Flatted.parse(data));
      const $layoutContainer = $('.layout-container').addClass("txrh-logged-out");
      let menuData = null;

      $('.cart-items-count').addClass('empty');
      if (data && data.length) {
        const json = Flatted.parse(data);
        const appState = json.appState;
        const accountLink = $('.profile-link');

        function removeHiddenProducts(product) {
          let hiddenProducts = Drupal.behaviors.cart.getHiddenProducts(menuData);
          //console.log('hiddenProducts', hiddenProducts);
          //console.log('product', product);
          //console.log('product.productId', product.productId);
          let id = parseInt(product.productId);
          //console.log('hiddenProducts.includes(id)', hiddenProducts.includes(id));
          return !hiddenProducts.includes(id);
        }

        if ( appState.authentication !== undefined && appState.authentication !== null ) {
          accountLink.attr('href','/account/settings').attr('title', 'My Account').attr('aria-label', 'My Account');
          $layoutContainer.removeClass('txrh-logged-out').addClass("txrh-logged-in");
        }

        if (appState.basket && appState.basket.id) {

          /*
           * The basket contains all products, even hidden ones like utensils
           * and/or condiments. We'll need to fetch the location menu so that
           * we can filter out "hidden" products.
           *
           * @see removeHiddenProducts() above.
           */
          $.ajax({
            url: settings.nomnom.apiUrl + '/olo/restaurants/' + appState.basket.vendorid + '/menu',
            dataType: 'json',
            success: function(json, textStatus, jqXHR) {
              menuData = json.categories;
            }
          });

          fetch(settings.nomnom.apiUrl + '/olo/baskets/' + appState.basket.id)
            .then(res => res.json())
            .then(res => {
              const cartProductsCount = res.products.filter(removeHiddenProducts).length;
              if (cartProductsCount > 0) {
                $('.cart-items-count').text(cartProductsCount).removeClass('empty');
              }
            }).catch(e => {
            $('.cart-items-count').parent().attr('href', '/order');
            console.log('basket fetch error: ', e);
          });
        } else {
          $('.cart-items-count').parent().attr('href', '/order');
        }

      } else {
        $('.cart-items-count').parent().attr('href', '/order');
      }
    },
    getHiddenProducts: function(menu) {
      // console.log('menu:', menu);
      let products = [];
      if ( menu !== null ) {
        for( let item in menu ) {
          // console.log('menu[item]', menu[item]);
          if ( menu[item].metadata != null ) {
            for( let k in menu[item].metadata) {
              if ( menu[item].metadata[k].key == 'display' && menu[item].metadata[k].value == 'hidden') {
                for(let product in menu[item].products) {
                  // console.log('hidden menu[item]', menu[item]);
                  products.push(parseInt(menu[item].products[product].id));
                }
              }
            }
          }
        }
      }

      return products;
    }
  };
})(Drupal, jQuery, drupalSettings);
